import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { findPurchaseOrder } from '../../redux/actions/purchaseOrders';
import { createWarehouseReceivingOrder } from '../../redux/actions/receivingOrders';


const NewReceivingOrderForm = ({ 
  payload,
  loadPurchaseOrder,
  purchaseOrders,
  newReceivingOrder,
  createWRO,
  settings, 
}) => {
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [scanTerm, setScanTerm] = useState('');

  const [scanBackgroundColor, setScanBackgroundColor] = useState('primary20');
  const [scanMessage, setScanMessage] = useState('Scan received items to receive below');

  const [notes, setNotes] = useState(null);

  const [receivedItems, setReceivedItems] = useState({});
  const [totalCount, setTotalCount] = useState(0.0);
  const { id } = useParams();

  useEffect(() => {
    loadPurchaseOrder(payload, id);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(scanTerm !== ''){
        if(purchaseOrders.activePurchaseOrder) { receiveScan(scanTerm) };
        setScanTerm('');
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [scanTerm, 500]);

  useEffect(() => {
    if(newReceivingOrder) { navigate(-1) };
  }, [newReceivingOrder]);

  const updateScan = (event) => {
    let value = event.target.value;
    setScanTerm(value);
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;
    setField(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const updateReceived = (event, purchaseOrderLineId) => {
    let value = event.target.value;
    let newItems = { ...receivedItems };
    let allItemsCount = 0;

    if(newItems[purchaseOrderLineId] === null || newItems[purchaseOrderLineId] === undefined) {
      newItems[purchaseOrderLineId] = {};
    }

    newItems[purchaseOrderLineId].count = parseFloat(value) || 0.0;

    for( var key in newItems ) {
      allItemsCount += newItems[key].count
    }

    setReceivedItems(newItems);
    setTotalCount(allItemsCount);
  }

  const updateTaxAdjustment = (event, purchaseOrderLineId) => {
    let value = event.target.value;
    let newItems = { ...receivedItems };
   
    if(newItems[purchaseOrderLineId] === null || newItems[purchaseOrderLineId] === undefined) {
      newItems[purchaseOrderLineId] = {};
    }

    if(!isNaN(parseFloat(value))) {
      newItems[purchaseOrderLineId].adjustedLineTax = parseFloat(value);
    } else {
      newItems[purchaseOrderLineId].adjustedLineTax = null;
    }

    setReceivedItems(newItems);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const receiveAll = (purchaseOrderLine) => {
    let newItems = { ...receivedItems };
    let allItemsCount = 0;

    if(newItems[purchaseOrderLine.id] === null || newItems[purchaseOrderLine.id] === undefined) {
      newItems[purchaseOrderLine.id] = {};
    }

    newItems[purchaseOrderLine.id].count = purchaseOrderLine.remaining_count || purchaseOrderLine.count;

    if(purchaseOrderLine.remaining_count === 0) {
      newItems[purchaseOrderLine.id].count = 0;
    }

    for( var key in newItems ) {
      allItemsCount += newItems[key].count
    }

    setReceivedItems(newItems);
    setTotalCount(allItemsCount);
  }

  const receiveOrder = () => {
    let newItems = { ...receivedItems };
    let allItemsCount = 0;

    purchaseOrders.activePurchaseOrder.purchase_order_lines.purchase_order_lines.forEach((purchaseOrderLine) => {
      if(newItems[purchaseOrderLine.id] === null || newItems[purchaseOrderLine.id] === undefined) {
        newItems[purchaseOrderLine.id] = {};
      }

      newItems[purchaseOrderLine.id].count = purchaseOrderLine.remaining_count || purchaseOrderLine.count;

      if(purchaseOrderLine.remaining_count === 0) {
        newItems[purchaseOrderLine.id].count = 0;
      }
    });

    for( var key in newItems ) {
      allItemsCount += newItems[key].count
    }

    setReceivedItems(newItems);
    setTotalCount(allItemsCount);
  }

  const flashScanBar = () => {
    let scanBarElement = document.querySelector("#scan-bar");

    setTimeout(() => {
      scanBarElement?.classList?.add("blink-action");
    }, 500);

    setTimeout(() => {
      scanBarElement?.classList?.remove("blink-action");
    }, 1500);
  }

  const receiveScan = (scanTerm) => {
    let matchingLine = purchaseOrders.activePurchaseOrder.purchase_order_lines.purchase_order_lines.find(orderLine => (orderLine.source_sku === scanTerm) || (orderLine.source_upc === scanTerm))
  
    if(matchingLine) {
      let newItems = { ...receivedItems };

      if(newItems[matchingLine.id] === null || newItems[matchingLine.id] === undefined) {
        newItems[matchingLine.id] = { count: 0 };
      }

      newItems[matchingLine.id].count += 1;

      setReceivedItems(newItems);
      setTotalCount(totalCount + 1);

      setScanBackgroundColor('success20');
      setScanMessage(`Found ${scanTerm}, increased receive count by 1`);
    } else {
      setScanBackgroundColor('danger20');
      setScanMessage(`${scanTerm} not found.`);
    }
  }

  const submit = () => {
    setSubmitted(true);
    createWRO(payload, id, receivedItems, notes);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }


  return(
    <>
      <PageHeader stripeBackground='#fbe194' helpLink="ecwid/create-a-warehouse-receiving-order-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Update and Receive Order</div>
              </div>
              <div className="named-area__description">
                <p>Create a warehouse receiving order for this purchase order.</p>
                <p>Receive items from a shipment by updating receive counts in the "Purchase Order Line Items" panel. You can update this value in three ways: scan item barcodes as they're unpacked by clicking in the "Scan Barcode" bar and scanning item, barcodes, clicking the "Receive All" button on an item's row, or manually updating the "Receive Count" field directly.</p>
                <p>Scanning items will increase the count by 1 each time an item is scanned.</p>
                <p>The "Receive All" button will set the count to the total number ordered.</p>
                <p>Update taxes for lines in the "Update Tax Adjustment" field if new tax/duties information is available.</p>
                <p>Include additional notes (such as the shipment number being received) by filling in the Notes section below.</p>
                <p>When all the information about this warehouse receiving order has been input, click the "Submit Warehouse Receiving Order" button to complete the order.</p>
                <p>Each warehouse receiving order will appear as a new page in the purchase order PDF the next time it's downloaded.</p>
                <p>Purchase orders that have all of their items received will be marked fulfilled. When only some of their items have been received, purchase orders will be marked "partially fulfilled".</p>

              </div>
            </div>
            <div className="named-area__body">
              { !purchaseOrders.activePurchaseOrder && 
                <LoadingSpinner statusText="Loading Purchase Order" />
              }

              { purchaseOrders.activePurchaseOrder && 

              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <h4>Invoice: {purchaseOrders.activePurchaseOrder.invoice_number}</h4>
                    <strong>Supplier Order: {purchaseOrders.activePurchaseOrder.supplier_order_number}</strong>
                    <br/>
                    <br/>
                    
                    <h4>Scan Barcodes</h4>

                    <div className="iconable-block iconable-block--hide-in-mobile">
                      <div className="iconable-block__infographics">
                        <span className="iconable-block__icon">
                          <svg width="18" height="18" fill="#189dee" viewBox="0 0 32 32" id="svg5" version="1.1">
                            <defs id="defs2"/>
                            <g id="layer1" transform="translate(-108,-100)">
                              <path d="m 111,106 a 1.0001,1.0001 0 0 0 -1,1 v 3 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -2 h 2 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z" id="path11698" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 134,106 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 2 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -3 a 1.0001,1.0001 0 0 0 -1,-1 z" id="path11700" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 137,121 a 1,1 0 0 0 -1,1 v 2 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 3 a 1.0001,1.0001 0 0 0 1,-1 v -3 a 1,1 0 0 0 -1,-1 z" id="path11702" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 111,121 a 1,1 0 0 0 -1,1 v 3 a 1.0001,1.0001 0 0 0 1,1 h 3 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -2 v -2 a 1,1 0 0 0 -1,-1 z" id="path11704" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 115,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11706" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 118,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11708" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 121,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11710" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 124,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11712" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 127,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11714" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 130,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11716" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                              <path d="m 133,110 a 1,1 0 0 0 -1,1 v 5.20703 1.31445 V 121 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 V 117.52148 116.20703 111 a 1,1 0 0 0 -1,-1 z" id="path11720" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <div className="iconable-block__content">
                        <div className="status-block">
                          <div className="status-block__central">
                            <div className="status-block__header">
                              <span className="status-block__title">Scan Barcode (SKU, UPC, EAN)</span>
                              <span className="status-block__edit">Edit</span>
                            </div>
                            <div className="status-block__content">
                              <div className="fieldset fieldset__max">
                                <div id="scan-bar" className="field field--large">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Scan Value</label>
                                  
                                  { !submitted && <input type="text" value={scanTerm} onFocus={focus} onBlur={blur} onChange={updateScan} className="field__input" tabindex="4" /> }
                                  { submitted && <input type="text" value={scanTerm} onFocus={focus} onBlur={blur} onChange={updateScan} className="field__input" tabindex="4" disabled /> }
                                  
                                  <div className="field__placeholder">Click here to begin scanning</div>
                                  <span className="field-state--success"></span>
                                  <span className="field-state--close"></span>
                                </div>
                                <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>





                    { !purchaseOrders.activePurchaseOrder &&
                      <LoadingSpinner statusText="Loading Purchase Order Details" />
                    }
                  </div>
                </div>


                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { purchaseOrders.activePurchaseOrder &&
                      <button
                        className="btn btn-default"
                        onClick={() => receiveOrder()}
                      >
                        Mark Entire Order Received
                      </button>
                    }

                     <h3>Purchase Order Line Items</h3>
                    { !purchaseOrders.activePurchaseOrder &&
                      <LoadingSpinner statusText="Loading Purchase Order Details" />
                    }

                    { purchaseOrders.activePurchaseOrder && purchaseOrders.activePurchaseOrder.purchase_order_lines.purchase_order_lines.map(purchaseOrderLine => 
                      <>
                      <div className="has-hover sku-line">
                        <strong>{ purchaseOrderLine.source_name }</strong>
                        <div className="flex-container">
                          <div className="flex-1">
                            { purchaseOrderLine.source_image_url && <img src={purchaseOrderLine.source_image_url} /> }
                            { !purchaseOrderLine.source_image_url && <p>No image</p>}
                          </div>

                          <div className="flex-2">
                            { purchaseOrderLine?.source_options?.map(option =>
                              <>
                                <strong>{ option.name }</strong>: { option.value }<br/>
                              </>
                            )}
                          </div>

                          <div className="flex-2">
                            <strong>Expected Quantity</strong>: { purchaseOrderLine.count }
                            { !!purchaseOrderLine.remaining_count && 
                              <>
                                <br/>
                                <strong>Remaining Expected Quantity</strong>: { purchaseOrderLine.remaining_count }
                                <button
                                  className="btn btn-default"
                                  onClick={() => receiveAll(purchaseOrderLine)}
                                >
                                  Receive All
                                </button>
                              </>
                            }
                            { settings?.settings?.pack_quantities && parseInt(purchaseOrderLine.pack_quantity) > 1 &&
                              <>
                                <br/>
                                <strong>Pack Quantity</strong>: {purchaseOrderLine.pack_quantity}
                              </>
                            }
                            { !purchaseOrderLine.remaining_count && 
                              <>
                                <br/>
                                <strong>Remaining Expected Quantity</strong>: 0
                              </>
                            }
                            <br/>
                            <strong>Supplier SKU</strong>: { purchaseOrderLine.supplier_sku }<br/>
                            <strong>SKU</strong>: { purchaseOrderLine.source_sku }<br/>
                            <strong>UPC</strong>: { purchaseOrderLine.source_upc }<br/>
                            <br/>
                            <strong>Unit Cost</strong>: { purchaseOrderLine.supplier_price }<br/>
                            { purchaseOrderLine.adjusted_tax && <><strong>Adjusted Line Tax</strong>: { purchaseOrderLine.adjusted_tax }<br/></> }

                          </div>

                          <div className="flex-2">
                            <div className="fieldset">
                              <div className="field field--medium field--filled">
                                <span className="fieldset__svg-icon"></span>
                                <label className="field__label">Quantity</label>
                                <input
                                  id={`scan-count-${purchaseOrderLine.id}`}
                                  onChange={(event) => updateReceived(event, purchaseOrderLine.id)}
                                  type="number"
                                  min="0"
                                  value={receivedItems[purchaseOrderLine.id]?.count}
                                  disabled={submitted}
                                  onFocus={focus}
                                  onBlur={blur}
                                  className="field__input"
                                />
                                <div className="field__placeholder">Quantity</div>
                              </div>

                                { !!(receivedItems[purchaseOrderLine.id]?.count && (parseFloat(receivedItems[purchaseOrderLine.id]?.count) > parseFloat(purchaseOrderLine.remaining_count || purchaseOrderLine.count))) &&
                                  <div className="flex-container">
                                    <div className="text-small error">Quantity is higher than expected</div>
                                  </div>
                                }
                                { !!(receivedItems[purchaseOrderLine.id]?.count && (parseFloat(receivedItems[purchaseOrderLine.id]?.count) === parseFloat(purchaseOrderLine.remaining_count || purchaseOrderLine.count))) &&
                                  <div className="flex-container">
                                    <div className="text-small success">Quantity matches</div>
                                  </div>
                                }

                                <div className="field field--medium">
                                  <span className="fieldset__svg-icon"></span>
                                  <label className="field__label">Adjust Tax Cost</label>
                                  <input
                                    id={`update-adjustment-tax-cost-${purchaseOrderLine.id}`}
                                    onChange={(event) => updateTaxAdjustment(event, purchaseOrderLine.id)}
                                    type="number"
                                    min="0"
                                    value={receivedItems[purchaseOrderLine.id]?.adjustedLineTax}
                                    disabled={submitted}
                                    onFocus={focus}
                                    onBlur={blur}
                                    className="field__input"
                                  />
                                  <div className="field__placeholder">Adjust Tax Cost</div>

                                </div>
                              </div>

                          </div>
                        </div>
                      </div>
                      <hr/>
                   </> 
                  )}


                  </div>
                </div>


                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    <div className="fieldset fieldset--textarea">
                      <div className="fieldset__title">Receiving Notes</div>
                      <div className="field">
                        <textarea 
                          className="field__textarea" 
                          tabindex="1"
                          maxlength="200"
                          onChange={(e) => setFieldValue(setNotes, e)}
                          value={notes}
                          onFocus={focus}
                          onBlur={blur}
                        >  
                        </textarea>
                        <div className="field__placeholder">Receiving notes</div>
                      </div>
                    </div>


                  </div>
                </div>

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    <button
                      className="btn btn-primary"
                      disabled={(totalCount === 0.0) || submitted}
                      onClick={() => submit()}
                      isLoading={submitted}
                    >
                      Submit Warehouse Receiving Order
                    </button>

                  </div>
                </div>


              </div>
            }




            </div>
          </div>



        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  purchaseOrders: state.purchaseOrders,
  newReceivingOrder: state.receivingOrders.newReceivingOrder,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadPurchaseOrder: (payload, purchaseOrderId) => dispatch(findPurchaseOrder(payload, purchaseOrderId, null)),
  createWRO: (payload, purchaseOrderId, receivedItems, notes) => dispatch(createWarehouseReceivingOrder(payload, purchaseOrderId, receivedItems, notes))
});

export default connect(mapStateToProps, mapDispatchToProps)(NewReceivingOrderForm);